import { useQuery } from '@apollo/client'
import { GetDefaultPrice, GetDefaultPriceInput, GetDefaultPriceVariables } from '../../types'
import { GET_DEFAULT_PRICES } from './operations'

interface Props {
  filter: GetDefaultPriceInput
  page: number
  pageLength: number
}

export const useDefaultPrices = ({ filter, page, pageLength }: Props) =>
  useQuery<GetDefaultPrice, GetDefaultPriceVariables>(GET_DEFAULT_PRICES, {
    variables: {
      inputData: {
        ...filter,
      },
      pagination: {
        from: pageLength * (page - 1),
        length: pageLength,
      },
    },
  })
